import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17923e4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "drawer_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drawer_title_txt" }, "活动抽奖", -1))
const _hoisted_4 = { class: "drawer_content" }
const _hoisted_5 = { class: "drawer_action_group" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "drawer_action_group" }
const _hoisted_8 = { class: "drawer_list" }
const _hoisted_9 = {
  key: 0,
  class: "null_box"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "drawer_item_header" }
const _hoisted_13 = { class: "drawer_item_header_title mod_ellip" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "diht" }, "活动名称：", -1))
const _hoisted_15 = { class: "drawer_item_main" }
const _hoisted_16 = { class: "drawer_item_content" }
const _hoisted_17 = { class: "drawer_item_content_img" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "drawer_item_content_form" }
const _hoisted_20 = { class: "dicf_item" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "drawer_item_conten_action" }
const _hoisted_23 = { class: "item_select_arrow" }
const _hoisted_24 = {
  key: 1,
  class: "baseline"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal_p" }, "抽奖前是否先展示此奖项全部奖品", -1))
const _hoisted_26 = { class: "modal_line" }

import { computed, reactive, ref } from 'vue';
import { Button, Modal, message, Switch, Select, Tooltip, InputNumber, Alert } from 'ant-design-vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import CDelModal, { RootModal } from '@/components/CDelModal.vue';
import CreateActiviLogttery from './CreateActiviLogttery.vue';
import SignConfig from './SignConfig.vue';
import http from '@/api';
import router from '@/router';
import ClipboardJS from 'clipboard';
import { ActionList, AddViewClass, Applicant } from './lottery';
import { emptyDataSec } from '@/assets';
import WinningEvent from './WinningEvent.vue';
import { useDebounce } from '@/hooks/useDebounce'; //防抖


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityLogttery',
  emits: ['click:onCloseLotter'],
  setup(__props, { emit }) {

const aButton = Button;
const aSwitch = Switch;
const aSelect = Select;
const aTooltip = Tooltip;
const aInputNumber = InputNumber;
const aModal = Modal;
const aAlert = Alert;

const onClose = () => {
  emit('click:onCloseLotter');
};
const studioId = router.currentRoute.value.params.studioId;

// 复制
const copyUrl = (url: string) => {
  const ClipboardJSObj = new ClipboardJS(url);
  ClipboardJSObj.on('success', (e) => {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', () => {
    message.destroy();
    message.info('复制失败');
  });
};

// 获取列表
const logtter = ref<ActionList[]>([]);
const addressJoin = ref(); //线下参与地址
const lastPage = ref(); //最后一页数据
const loadpageSize = ref(1); // 第几页数据
const noMore = ref(false); //判断是否有更多数据
const drawNum = ref(); //参与人数
const drawIds = ref();
const rewardIds = ref();
const getDrawActive = (current: any) => {
  const data = {
    studio_id: studioId,
    page: current,
    page_num: 5,
  };
  http.lottery.getDrawActive({ params: data }).then((res) => {
    addressJoin.value = res.data.data.link;
    lastPage.value = res.data.data.last_page;
    drawNum.value = res.data.data.num;
    if (res.data.data.data) {
      logtter.value.push(...res.data.data.data);
      logtter.value.forEach((item, index) => {
        item.image =
          item.data && item.reward_id === 0
            ? item.data[0] && item.data[0].reward[0]
              ? item.data[0].reward[0].pic_url
              : ''
            : item.pic_url;
        const title = ref();
        const titleSon = ref();
        item.data.forEach((e) => {
          if (e.id === item.draw_id) title.value = e.title;
          e.reward.forEach((i) => {
            if (i.id === item.reward_id) titleSon.value = i.title;
          });
        });
        item.selectAwards = item.data && item.draw_id == 0 ? (item.data[0] ? item.data[0].title : ' ') : title.value;
        item.selectPrize =
          item.data && item.reward_id == 0
            ? item.data[0] && item.data[0].reward[0]
              ? item.data[0].reward[0].title
              : ''
            : titleSon.value;
        item.statuSw = item.status === 1 ? true : false;
        item.selectAwardId = item.data && item.draw_id == 0 ? (item.data[0] ? item.data[0].id : '') : item.draw_id;
        item.selectPrizeId =
          item.data && item.reward_id == 0
            ? item.data[0] && item.data[0].reward[0]
              ? item.data[0].reward[0].id
              : ''
            : item.reward_id;
        item.selectAwardNum =
          item.start_status !== 0
            ? item.number
            : item.data
            ? item.data[0] && item.data[0].reward[0]
              ? item.data[0].reward[0].number
              : 0
            : 0;
      });
    }
  });
};
getDrawActive(1);
//滚动加载数据
const getChildList = () => {
  if (loadpageSize.value >= lastPage.value) {
    noMore.value = true;
  } else {
    noMore.value = false;
    loadpageSize.value++;
    // console.log(loadpageSize.value);
    getDrawActive(loadpageSize.value);
  }
};
const drawIdTest = ref();
// 切换奖项
const changeSel = (item: any) => {
  item.data.forEach((element: any) => {
    if (item.selectAwardId === element.id) {
      item.selectPrize = element.reward[0].title;
      item.image = element.reward[0].pic_url;
      item.selectAwardId = element.id;
      item.selectPrizeId = element.reward[0].id;
      item.selectAwardNum = element.reward[0].number;
    }
  });
};
const rewardIdTest = ref();
// 切换奖品
const changePrize = (item: any, i: any) => {
  i.reward.forEach((element: any) => {
    if (item.selectPrizeId === element.id) {
      item.image = element.pic_url;
      item.selectPrizeId = element.id;
      item.selectAwardNum = element.number;
    }
  });
};

// 列表开关
const onChangeDraw = useDebounce((i: number, e: any) => {
  message.destroy();
  const data = {
    studio_id: studioId,
    id: e.id,
    status: e.statuSw ? 0 : 1,
  };
  http.lottery
    .drawSwitchNew(data)
    .then((res) => {
      logtter.value[i].statuSw = !e.statuSw;
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
});
// 奖品展示
const showOpenDraw = ref(false);
const itemDraw = ref();
const onOpenDraw = (item: any) => {
  message.destroy();
  if (item.selectAwardNum === 0) {
    message.error('中奖名额不能少于1人');
  } else {
    showOpenDraw.value = true;
    itemDraw.value = item;
  }
};
const drawReadyNew = (type: number) => {
  const all = ref();
  type === 1 ? (all.value = 1) : (all.value = 0);
  const data = {
    all: all.value,
    draw_id: itemDraw.value.selectAwardId,
    id: itemDraw.value.id,
    number: itemDraw.value.selectAwardNum,
    reward_id: itemDraw.value.selectPrizeId,
    studio_id: studioId,
  };
  http.lottery
    .drawReadyNew(data)
    .then((res) => {
      message.success(res.data.message);
      itemDraw.value.start_status = 1;
      showOpenDraw.value = false;
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
// 开始抽奖
const startVisible = ref(false);
const Sitem = ref();
const OpenSVisible = (item: any) => {
  message.destroy();
  Sitem.value = item;
  if (drawIdTest.value) drawIds.value = drawIdTest.value;
  else drawIds.value = item.data && item.draw_id == 0 ? (item.data[0] ? item.data[0].id : '') : item.draw_id;
  if (rewardIdTest.value) rewardIds.value = rewardIdTest.value;
  else
    rewardIds.value =
      item.data && item.reward_id == 0
        ? item.data[0] && item.data[0].reward[0]
          ? item.data[0].reward[0].id
          : ''
        : item.reward_id;
  startVisible.value = !startVisible.value;
};
const onStartDraw = () => {
  const data = {
    draw_id: Sitem.value.selectAwardId,
    id: Sitem.value.id,
    reward_id: Sitem.value.selectPrizeId,
    studio_id: studioId,
    number: Sitem.value.selectAwardNum,
  };
  http.lottery
    .drawStartNew(data)
    .then((res) => {
      message.success(res.data.message);
      startVisible.value = false;
      Sitem.value.start_status = 2;
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
// 结束抽奖
const endVisible = ref(false);
const Eitem = ref();
const openeVisible = (item: any) => {
  message.destroy();
  Eitem.value = item;
  endVisible.value = !endVisible.value;
};
const drawEndNew = () => {
  const data = {
    draw_id: Eitem.value.selectAwardId,
    id: Eitem.value.id,
    reward_id: Eitem.value.selectPrizeId,
    studio_id: studioId,
    number: Eitem.value.selectAwardNum,
  };
  http.lottery
    .drawEndNew(data)
    .then((res) => {
      message.success(res.data.message);
      endVisible.value = false;
      Eitem.value.start_status = 0;
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

// 筛选标记
const selectKeys = ref({});
const delIds = ref();
const getSelectIds = computed(() => {
  const selectArr = Array<any>();
  Object.keys(selectKeys.value).forEach((e) => {
    if (selectKeys.value[e] === true) {
      selectArr.push(e);
      delIds.value = selectArr.toString();
    }
  });
  return selectArr.join(',');
});
const getSelected = computed(() => Boolean(!getSelectIds.value));
const choice = ref(false);
const isSelect = computed(() => (choice.value ? 'item_select' : ''));
const isSelected = (data: ActionList) => (selectKeys.value[data.id] ? 'item_selected' : '');
const changeItemMark = (item: ActionList) => {
  if (choice.value) {
    selectKeys.value[item.id] = !selectKeys.value[item.id];
  }
};
const getList = () => {
  selectKeys.value = {};
  choice.value = false;
  logtter.value.forEach((e: ActionList) => {
    selectKeys.value[e.id] = false;
  });
};
getList();

// 删除
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});
const openDelModal = () => {
  delModal.visible = !delModal.visible;
};
const onRemoveSLItem = () => {
  const data = {
    ids: delIds.value,
    studio_id: studioId,
  };
  http.lottery
    .drawDeleNew(data)
    .then((res) => {
      message.success(res.data.message);
      loadpageSize.value = 1;
      logtter.value = [];
      getDrawActive(1);
      delModal.loading = false;
      delModal.visible = false;
    })
    .catch((err) => {
      message.error(err.data.error);
    });
  // test
  getList();
};

// 二级页面
// 获取 报名人数 该抽奖详情
const applicants = ref<Applicant>({
  fixed: 0, //内定名单 报名人数
  local: 0, // 本地名单 报名人数
  user: 0, // 观众参与 报名人数
});
const getApplicants = (id: number) => {
  const data = {
    studio_id: studioId,
    draw_new_id: id,
  };
  http.lottery.getMemberNumNew({ params: data }).then((res) => {
    applicants.value = res.data.data;
  });
};
const addPageViewData = ref(); //编辑页面数据
const secPage = ref(false);
const addPageVisible = ref(false);
const createEnid = ref(false); //false 新建  true 编辑
const onOpenAddPage = (id: number, showView: boolean) => {
  // 获取 抽奖参与人数 本地观众内定 人数
  createEnid.value = false;
  if (id > 0) {
    getApplicants(id);
    createEnid.value = showView;
    // 获取详情
    const from = {
      studio_id: studioId,
      id: id,
    };
    http.lottery.drawViewNew({ params: from }).then((res) => {
      addPageViewData.value = new AddViewClass(res.data.data);
      secPage.value = true;
      addPageVisible.value = true;
    });
  } else {
    addPageViewData.value = {
      bg_pc_url: process.env.VUE_APP_OTHER_LINK+'/lottery_pc_bg.png',
      bg_url: process.env.VUE_APP_OTHER_LINK+'/lottery_mobile_bg.png',
      list: 0,
    };
    applicants.value = {
      fixed: 0, //内定名单 报名人数
      local: 0, // 本地名单 报名人数
      user: 0, // 观众参与 报名人数
    };
    secPage.value = true;
    addPageVisible.value = true;
  }
};
const callbackPage = () => {
  secPage.value = false;
  addPageVisible.value = false;
  winShow.value = false;
  showConfig.value = false;
  logtter.value = [];
  loadpageSize.value = 1;
  getDrawActive(1);
};
const onBack = () => {
  secPage.value = false;
  addPageVisible.value = false;
  winShow.value = false;
  showConfig.value = false;
};
const winShow = ref(false);
const winShowId = ref();
const winDrawId = ref();
const winRewardId = ref();
const onWinShow = (item: any) => {
  winShowId.value = item.id;
  winDrawId.value = 0;
  winRewardId.value = 0;
  winShow.value = true;
  secPage.value = true;
};
// 报名配置
const showConfig = ref(false);
const signClick = () => {
  secPage.value = true;
  showConfig.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(aButton), {
          type: "link",
          class: "drawer_title_close",
          onClick: onClose
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CloseOutlined))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(aAlert), {
          message: "每个抽奖活动的设置都是独立的，支持配置多个奖项以及奖品，可用于多轮开奖。",
          type: "warning",
          closable: "",
          banner: ""
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createVNode(_unref(aButton), {
              class: "drawer_action_btn lg",
              onClick: onOpenAddPage
            }, {
              default: _withCtx(() => [
                _createTextVNode("新建抽奖")
              ]),
              _: 1
            }),
            _createVNode(_unref(aTooltip), null, {
              title: _withCtx(() => [
                _createTextVNode("点击复制")
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(aButton), {
                  class: "drawer_action_btn lg link",
                  "data-clipboard-text": addressJoin.value,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (copyUrl('.link')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("线下参与地址")
                  ]),
                  _: 1
                }, 8, ["data-clipboard-text"])
              ]),
              _: 1
            }),
            _createVNode(_unref(aButton), {
              class: "drawer_action_btn lg",
              onClick: signClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("报名配置")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("span", _hoisted_6, "参与人数: " + _toDisplayString(drawNum.value) + "人", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(aButton), {
            class: _normalizeClass(["drawer_action_btn", { checked: choice.value === true }]),
            onClick: _cache[1] || (_cache[1] = () => (choice.value = !choice.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode("选择")
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_unref(aButton), {
            class: "drawer_action_btn",
            disabled: _unref(getSelected),
            onClick: openDelModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("删除")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (logtter.value.length < 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: _unref(emptyDataSec),
                  class: "null_img"
                }, null, 8, _hoisted_10)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logtter.value, (item, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass([[_unref(isSelect), isSelected(item)], "drawer_item"]),
              onClick: ($event: any) => (changeItemMark(item))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(" " + _toDisplayString(item.title), 1)
                ]),
                _createVNode(_unref(aSwitch), {
                  checked: item.statuSw,
                  class: "dict_title_switch",
                  "checked-children": "开",
                  "un-checked-children": "关",
                  onChange: ($event: any) => (_unref(onChangeDraw)(index, item))
                }, null, 8, ["checked", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("img", {
                      src: item.image,
                      width: "129",
                      height: "129",
                      alt: ""
                    }, null, 8, _hoisted_18)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_unref(aSelect), {
                        value: item.selectAwardId,
                        "onUpdate:value": ($event: any) => ((item.selectAwardId) = $event),
                        class: "dicf_item_select",
                        onChange: ($event: any) => (changeSel(item)),
                        disabled: item.start_status === 0 ? false : true
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (o) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: o.id,
                              value: o.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(o.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value", "onChange", "disabled"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "dicf_item",
                        key: i.id
                      }, [
                        (item.selectAwardId === i.id)
                          ? (_openBlock(), _createBlock(_unref(aSelect), {
                              key: 0,
                              value: item.selectPrizeId,
                              "onUpdate:value": ($event: any) => ((item.selectPrizeId) = $event),
                              class: "dicf_item_select",
                              onChange: ($event: any) => (changePrize(item, i)),
                              disabled: item.start_status === 0 ? false : true
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.reward, (e) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: e.id,
                                    value: e.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(e.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value", "onChange", "disabled"]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.reward, (e) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "dicf_item",
                            key: e.id
                          }, [
                            (item.selectPrizeId === e.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createVNode(_unref(aInputNumber), {
                                    value: item.selectAwardNum,
                                    "onUpdate:value": ($event: any) => ((item.selectAwardNum) = $event),
                                    class: "dicf_item_input",
                                    min: 0
                                  }, null, 8, ["value", "onUpdate:value"]),
                                  _createTextVNode("人 ")
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_unref(aButton), {
                    type: "link",
                    class: _normalizeClass(["dica_link_btn", { disable: item.start_status !== 0 }]),
                    onClick: ($event: any) => (onOpenAddPage(item.id, true)),
                    disabled: item.start_status === 0 ? false : true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("编辑")
                    ]),
                    _: 2
                  }, 1032, ["onClick", "class", "disabled"]),
                  _createVNode(_unref(aButton), {
                    type: "link",
                    class: "dica_link_btn",
                    onClick: ($event: any) => (onWinShow(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("中奖记录")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (item.start_status === 0)
                    ? (_openBlock(), _createBlock(_unref(aButton), {
                        key: 0,
                        class: "dica_sub prize_display",
                        type: "primary",
                        onClick: ($event: any) => (onOpenDraw(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("奖品展示")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (item.start_status === 1)
                    ? (_openBlock(), _createBlock(_unref(aButton), {
                        key: 1,
                        class: "dica_sub",
                        type: "primary",
                        onClick: ($event: any) => (OpenSVisible(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("开始抽奖")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (item.start_status === 2)
                    ? (_openBlock(), _createBlock(_unref(aButton), {
                        key: 2,
                        class: "dica_sub prize_end",
                        type: "primary",
                        onClick: ($event: any) => (openeVisible(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("结束抽奖")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_svg_icon, {
                    class: "item_select_arrow_icon",
                    "icon-class": "checked"
                  })
                ])
              ])
            ], 10, _hoisted_11)), [
              [_directive_infinite_scroll, getChildList]
            ])
          }), 128)),
          (noMore.value && logtter.value.length > 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, "我是有底线的-.-"))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !secPage.value]
    ]),
    (secPage.value && winShow.value)
      ? (_openBlock(), _createBlock(WinningEvent, {
          key: 0,
          data: { id: winShowId.value, draw_id: winDrawId.value, reward_id: winRewardId.value },
          "onClick:callbackWinPage": onBack
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    (secPage.value && addPageVisible.value)
      ? (_openBlock(), _createBlock(CreateActiviLogttery, {
          key: 1,
          datails: { applicants: applicants.value, addPageViewData: addPageViewData.value, show: createEnid.value },
          "onClick:callbackPage": callbackPage,
          "onClick:onBack": onBack
        }, null, 8, ["datails"]))
      : _createCommentVNode("", true),
    (showConfig.value)
      ? (_openBlock(), _createBlock(SignConfig, {
          key: 2,
          "onClick:onBack": onBack,
          "onClick:callbackPage": callbackPage
        }))
      : _createCommentVNode("", true),
    _createVNode(CDelModal, {
      visible: delModal.visible,
      centered: "",
      close: openDelModal,
      ok: onRemoveSLItem
    }, null, 8, ["visible"]),
    _createVNode(CDelModal, {
      visible: startVisible.value,
      centered: "",
      close: () => (startVisible.value = false),
      ok: onStartDraw
    }, {
      title: _withCtx(() => [
        _createTextVNode("此操作将开始抽奖，是否继续?")
      ]),
      _: 1
    }, 8, ["visible", "close"]),
    _createVNode(CDelModal, {
      visible: endVisible.value,
      centered: "",
      close: () => (endVisible.value = false),
      ok: drawEndNew
    }, {
      title: _withCtx(() => [
        _createTextVNode("此操作将结束抽奖，是否继续?")
      ]),
      _: 1
    }, 8, ["visible", "close"]),
    _createVNode(_unref(aModal), {
      visible: showOpenDraw.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((showOpenDraw).value = $event)),
      footer: null,
      centered: "",
      width: "420px"
    }, {
      default: _withCtx(() => [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_unref(aButton), {
            class: "modal_but",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (drawReadyNew(0)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("否")
            ]),
            _: 1
          }),
          _createVNode(_unref(aButton), {
            class: "modal_but",
            type: "primary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (drawReadyNew(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("是")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})